import { Injectable } from '@angular/core';
import { CreateCommandHandler } from '../../../core/service/command/create-command-handler.service';
import { DeleteFormCommandHandler } from '../../../core/service/command/delete-form-command-handler.service';
import { FormCommandHandlerResolver } from '../../../core/service/command/form-command-handler-resolver.service';
import { mailCommand } from '../../../message/model/const/command';
import { SendTenantMailCommandHandler } from '../../../message/service/command/send-tenant-mail-command-handler.service';
import { leaseAgreementCommand } from '../../command/lease-agreement.command';
import { ApproveContractCommandHandler } from './approve-contact-command-handler.service';
import { CreateInvoiceCommandHandler } from './create-invoice-command-handler.service';
import { PrintContractCommandHandler } from './print-contract-command-handler.service';
import { PrintContractTerminationFormCommandHandler } from './print-contract-termination-form-command-handler';
import { PrintParkingContractFormCommandHandler } from './print-parkingcontract-command-handler';
import { ShowLeaseAgreementInvoicesCommandHandler } from './show-lease-agreement-invoices-command-handler';
import { TerminateContractCommandHandler } from './terminate-contract-command-handler.service';
import { WithdrawApprovalCommandHandler } from './withdraw-approval-command-handler.service';
import { WithdrawTerminationCommandHandler } from './withdraw-termination-command-handler.service';
import { LinkLeaseAgreementDocumentCommandHandler } from './link-lease-agreement-document-command-handler.service';
import { ShowDocumentsCommandHandler } from './show-documents-command-handler.service';
import { SendTenantSMSCommandHandler } from '../../../message/service/command/send-tenant-sms-command-handler.service';
import { VoidContractCommandHandler } from './void-contract-command-handler.service';
import { ESignLeaseAgreementContractCommandHandler } from './esign-lease-agreement-document-command-handler.service';
import { ESignKeyRecieptCommandHandler } from './esign-key-reciept-document-command-handler.service';
import { SendTenantEmailCommandHandler } from '../../../message/service/command/send-tenant-email-command-handler.service';

@Injectable()
export class ContractFormCommandHandlerResolver extends FormCommandHandlerResolver {
  constructor(
    approveHandler: ApproveContractCommandHandler,
    createHandler: CreateCommandHandler,
    createInvoiceHandler: CreateInvoiceCommandHandler,
    deleteHandler: DeleteFormCommandHandler,
    linkDocumentHandler: LinkLeaseAgreementDocumentCommandHandler,
    printTerminationFormHandler: PrintContractTerminationFormCommandHandler,
    sendEmailHandler: SendTenantEmailCommandHandler,
    sendMailHandler: SendTenantMailCommandHandler,
    sendSmsHandler: SendTenantSMSCommandHandler,
    terminateHandler: TerminateContractCommandHandler,
    voidHandler: VoidContractCommandHandler,
    esignLeaseAgreementDocumentHandler: ESignLeaseAgreementContractCommandHandler,
    withdrawApprovalHandler: WithdrawApprovalCommandHandler,
    withdrawTerminationHandler: WithdrawTerminationCommandHandler,
    printContractCommandHandler: PrintContractCommandHandler,
    printParkingContractCommandHandler: PrintParkingContractFormCommandHandler,
    showDocumentsHandler: ShowDocumentsCommandHandler,
    showInvoicesHandler: ShowLeaseAgreementInvoicesCommandHandler,
    eSignKeyRecieptHandler: ESignKeyRecieptCommandHandler
  ) {
    super(createHandler, deleteHandler);
    this.addHandler(leaseAgreementCommand.approve, approveHandler);
    this.addHandler(leaseAgreementCommand.createInvoice, createInvoiceHandler);
    this.addHandler(leaseAgreementCommand.linkDocument, linkDocumentHandler);
    this.addHandler(mailCommand.sendTenantEmail, sendEmailHandler);
    this.addHandler(mailCommand.sendTenantMail, sendMailHandler);
    this.addHandler(mailCommand.sendTenantSMS, sendSmsHandler);
    this.addHandler(leaseAgreementCommand.terminate, terminateHandler);
    this.addHandler(leaseAgreementCommand.void, voidHandler);
    this.addHandler(leaseAgreementCommand.withdrawApproval, withdrawApprovalHandler);
    this.addHandler(leaseAgreementCommand.withdrawTermination, withdrawTerminationHandler);
    this.addHandler(leaseAgreementCommand.print, printContractCommandHandler);
    this.addHandler(leaseAgreementCommand.printTerminationForm, printTerminationFormHandler);
    this.addHandler(leaseAgreementCommand.printParkingForm, printParkingContractCommandHandler);
    this.addHandler(leaseAgreementCommand.showDocuments, showDocumentsHandler);
    this.addHandler(leaseAgreementCommand.showInvoices, showInvoicesHandler);
    this.addHandler(leaseAgreementCommand.sendForEsignDocument, esignLeaseAgreementDocumentHandler);
    this.addHandler(leaseAgreementCommand.esignKeyReciept, eSignKeyRecieptHandler);
  }
}
